import style from './CustomLoader.module.css';

const CustomLoader = () => {
  return (
    <div className={style.centerLoading}>
      <div className={style.ldsellipsis}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default CustomLoader;
